import React, { useState, useEffect } from 'react';
import Modal from 'global/components/modal';
import useStyles from './styles';
import CloseIcon from '@material-ui/icons/Close';
import { Button, Icon, Typography, IconButton } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { get, size, set } from 'global/lib/lodash';
import clsx from 'clsx';
import setUserRealm from 'redux/actions/userRealm';
import { userHasPermissions } from 'redux/actions/userLogin';
import Styles, { Loader, useScreen } from 'global/styles';
import Alert from '@material-ui/lab/Alert';
import { Access } from 'global/components/droprealms';
import withRouter from 'react-router-dom/withRouter';
import { useUser } from 'global/hooks/useUser';

const TemplateButton = (props) => {
  const { title, secondButton, onClick } = props;
  const classes = useStyles();

  return (
    <div className={classes.flexRow}>
      <Button className={classes.templateButton} startIcon={<Icon>add</Icon>} onClick={onClick}>
        {title}
      </Button>
      {secondButton && (
        <Button className={clsx(classes.templateButton, classes.templateButton2)} onClick={secondButton.onClick}>
          <Icon>{secondButton.icon}</Icon>
        </Button>
      )}
    </div>
  );
};

const RealmReset = (props) => {
  const classes = useStyles();
  const realm = useSelector((state) => get(state, 'auth.realm'));
  const dispatch = useDispatch();

  const onReset = () => {
    dispatch(setUserRealm(null));
  };

  const hasRealm = get(realm, 'id');

  return !hasRealm ? null : (
    <div className={classes.realmReset}>
      Showing available templates for <Icon>room</Icon>
      {get(realm, 'name')} <Button onClick={onReset}>RESET</Button>
    </div>
  );
};

export default withRouter((props) => {
  const { templates, onDefaultSelect, startTemplateCreate } = props;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [selected, setSelected] = useState();
  const { isMobileXS } = useScreen();
  const { me } = useUser();
  const realm = useSelector((state) => get(state, 'auth.realm'));
  const classes = useStyles({ isMobileXS });
  const styles = Styles();

  const hasPerm = userHasPermissions('createReportTemplates');

  const onEdit = (temp) => {
    props.history.push(`assessment-template/${temp.id}`);
  };

  const submitTemplate = async (temp, realm) => {
    try {
      setLoading(true);
      const scorecards = {};
      Object.keys(temp.scores).map((k) => {
        set(scorecards, `scorecard_${k}`, k);
      });
      const err =
        props.onSelectTemplate &&
        (await props.onSelectTemplate({
          ...temp,
          ...scorecards,
          generalVisibility: get(temp, 'visibility'),
          template_id: temp.id,
          realmId: Object.keys(realm)[0],
          reportName: get(realm, [Object.keys(realm)[0], 'name'], get(temp, 'name', '')),
        }));
      if (err) {
        setError(err.message);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const selectTemplate = (temp) => {
    setSelected(temp);
  };

  useEffect(() => {
    if (props.open) {
      setSelected();
      setError();
      setLoading(false);
    }
  }, [props.open]);

  const all = get(templates, 'data', []);
  const global = all.filter((t) => get(t, 'status') === 'global_template');
  const mine = all.filter((t) => get(t, 'status') === 'template' && (get(t, 'authors', []).find((u) => u.id === me.id) || get(t, 'editors', []).find((u) => u.id === me.id)));

  const hasMine = size(mine) > 0;

  return (
    <Modal title={selected ? `NEW ${(get(selected, 'name') || '').toUpperCase()}` : 'CREATE ASSESSMENT'} maxWidth={800} {...props}>
      {loading && (
        <div className={clsx(classes.container, styles.centerColumn)}>
          <Loader />
        </div>
      )}

      {!loading && selected && (
        <div style={{ width: '100%', height: '100%' }}>
          <Access
            onlyTiers={['division', 'community', 'lot']}
            singleSelect={true}
            canAdd
            onSelectedChange={(sel) => {
              submitTemplate(selected, sel);
            }}
            openToSelected={true}
            currentRealm={realm || selected.realm}
          />
        </div>
      )}

      {!loading && !selected && (
        <div className={classes.container}>
          {error && (
            <Alert
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setError();
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {error}
            </Alert>
          )}
          <TemplateButton title="Custom Assessment" onClick={onDefaultSelect} />

          <div className={classes.grouping}>
            <RealmReset />
            {!!size(global) && (
              <>
                <Typography className={classes.header}>ALL TEMPLATES</Typography>
                {global.map((temp) => (
                  <TemplateButton onClick={() => selectTemplate(temp)} title={get(temp, 'name')} secondButton={{ icon: 'visibility', onClick: () => onEdit(temp) }} />
                ))}
              </>
            )}
          </div>

          {(hasPerm || hasMine) && (
            <div className={classes.grouping}>
              <div className={clsx(classes.flexRow)}>
                <Typography className={clsx(classes.header, classes.rowWidth)}>MY TEMPLATES</Typography>
                {hasPerm && (
                  <Button onClick={startTemplateCreate} className={clsx(classes.templateButton, classes.templateButton2)}>
                    <Icon>add</Icon>
                  </Button>
                )}
              </div>
              {mine.map((temp, i) => (
                <TemplateButton key={i} onClick={() => selectTemplate(temp)} title={get(temp, 'name')} secondButton={{ icon: 'edit', onClick: () => onEdit(temp) }} />
              ))}
              {!hasMine && <div className={classes.noneYet}>{`You haven't created any assessment templates yet`}</div>}
            </div>
          )}
        </div>
      )}
    </Modal>
  );
});
